import { createRequestTypes } from 'common/websocket-redux';

export const RESET_AUTH_FACTORS = createRequestTypes(
  'healthConciergeTooling/RESET_AUTH_FACTORS',
);

export const resetAuthFactors = ({ userId }) =>
  RESET_AUTH_FACTORS.request({ userId });
